import React, { useEffect } from 'react';
import styles from './Managment.module.css';
import { useTranslation } from 'react-i18next';
import { Button, Loader } from '@mantine/core';
import useControl from './hooks/useControl';

import cn from 'classnames';

const Managment = ({ id }) => {
  const { t } = useTranslation();
  const [{ control, fetched }, { fetch, unbound }] = useControl(t);

  useEffect(() => {
    fetch(id);
  }, []);

  if (!fetched) {
    return (
      <div className={styles.loader}>
        <Loader />
      </div>)
  }

  const handleClick = () => {
    unbound(id, {
      ...control,
      placeKey: null
    })
  }

  const showDate = (value) => {
    const myDate = new Date(value);
    let m = myDate.getMonth() + 1;
    let d = myDate.getDate();
    m = m > 9 ? m : '0' + m;
    d = d > 9 ? d : '0' + d;

    return `${d}.${m}.${myDate.getFullYear()}`;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.item}>
        <div className={styles.title}>
          {t('organization')}
        </div>

        <div className={styles.description}>
          {control?.organizationName || '—'}
        </div>
      </div>

      <div className={styles.itemDate}>
        <div className={styles.title}>
          {t('order.date')}
        </div>

        <div className={styles.description}>
          {control?.created ? showDate(control.created) : '—'}
        </div>
      </div>

      <Button className={cn(styles.button, !control && styles.unpublish)} onClick={handleClick}>
        {t(!control ? 'unbounded' : 'unbound')}
      </Button>
    </div>
  )
}

export default Managment;
